import React, { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./UpdateMatchPreferences.css";
import { useNavigate } from "react-router-dom";
import { Createorupdatelovelanguage } from "../api/api";
import RegistraionFlowHeader from "../RegistraionFlowHeader/RegistraionFlowHeader";
import bgImage from "../../assets/images/brown-background.jpg";

const fields = {
  preferred_love_receiving_method:
    "How do you prefer to receive love from your partner?",
  preferred_love_giving_method:
    "What is the most meaningful way for you to show love to someone?",
  importance_of_quality_time:
    "How important is quality time and undivided attention in your relationship?",
  words_vs_actions_affection:
    "How do you feel about expressing affection through words versus actions?",
  stress_support_preference:
    "What helps you feel most supported and cared for during stressful times?",
};

const validationSchema = Yup.object().shape(
  Object.fromEntries(
    Object.keys(fields).map((key) => [key, Yup.string().required("Required")])
  )
);

const UpdateMatchPreferences = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  return (
    <div
      className="match-preferences-container sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="containerall">
        <RegistraionFlowHeader />
        <div className="match-preferall">
          <h2 className="form-header">Love Language & Preferences</h2>

          <Formik
            initialValues={Object.fromEntries(
              Object.keys(fields).map((key) => [key, ""])
            )}
            // validationSchema={validationSchema}
            onSubmit={async (values) => {
              setLoading(true);
              try {
                const userDatas = JSON.parse(
                  localStorage.getItem("currentUser")
                );
                const _id = userDatas?.id || userDatas?._id;

                const transformedValues = Object.fromEntries(
                  Object.entries(values).map(([key, val]) => [
                    key,
                    val.trim() === "" ? null : val,
                  ])
                );

                const payload = {
                  user_id: _id,
                  profile_completion_status: "userAnswersTemperament",
                  ...transformedValues,
                };
                console.log("UpdateMatchPreferences", payload);
                const response = await Createorupdatelovelanguage(payload);
                console.log("API Response:", JSON.stringify(response));

                if (response?.success) {
                  navigate("/TemperamentQuestion"); // Adjust route name if needed
                } else {
                  alert(response.message || "Something went wrong.");
                }
              } catch (error) {
                console.error("API Error:", error);
                alert("Something went wrong. Please try again.");
              } finally {
                setLoading(false);
              }
            }}
          >
            {({ isSubmitting }) => (
              <Form className="form-content">
                {Object.entries(fields).map(([key, label]) => (
                  <div key={key} className="form-group">
                    <label className="form-label">{label}</label>
                    <Field
                      as="textarea"
                      name={key}
                      className="form-textarea"
                      placeholder="Type your answer"
                      rows={4}
                    />
                    <ErrorMessage
                      name={key}
                      component="div"
                      className="error-message"
                    />
                  </div>
                ))}

                <button
                  type="submit"
                  className="submit-button"
                  disabled={loading || isSubmitting}
                >
                  {loading ? "Submitting..." : "Continue"}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default UpdateMatchPreferences;
